'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

ColumnHeaderDirective=class ColumnHeaderDirective extends BaseControllerBackedDirective{
get restrict(){
return'A';
}

get objectBindings(){
return['tableColumn','sortableTableController'];
}

get templateUrl(){
return'/templates/directives/columnHeaderDirective/columnHeaderTemplate';
}

get controller(){
return ColumnHeaderDirectiveController;
}

factory(){
let directive=super.factory();
directive.replace=!0;
return directive;
}};let


ColumnHeaderDirectiveController=class ColumnHeaderDirectiveController{
get ascending(){
return this.tableColumn.ascending;
}

get isActive(){
return this.tableColumn.isActive;
}

get label(){
return this.tableColumn.label;
}

get orderBy(){
return this.tableColumn.orderBy;
}

get sortDisabled(){
return this.tableColumn.sortDisabled;
}};



module.exports=ColumnHeaderDirective;
//# sourceMappingURL=columnHeaderDirective.js.map
